import { praticaRecupera } from "common/_redux/pratica/actions";
import { praticaRiprendiSelector } from "common/_redux/pratica/selectors";
import BftButton from "common/components/button";
import BftInput from "common/components/input";
import MessageModal from "common/components/message-modal";
import { authRecuperaPraticaEmail } from "core/auth/_redux/action";
import { authRecuperaPraticaEmailSelector, authUserSelector } from "core/auth/_redux/selectors";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { FormEvent, useState } from "react";
import { Accordion, Card, Col } from "react-bootstrap";

const RecuperaPraticaCard: React.FC = () => {
	const dispatch = useAppDispatch();

	const email = useAppSelector(authRecuperaPraticaEmailSelector);

	const userInfo = useAppSelector(authUserSelector);
	const reopenPratica = useAppSelector(praticaRiprendiSelector);

	const [showModal, setShowModal] = useState(false);

	const isDesktop = window.innerWidth >= 768;

	const handleCloseModal = () => {
		setShowModal(false);
	};

	const handleShowModal = () => setShowModal(true);

	const handleRecuperaPratica = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (email) {
			dispatch(praticaRecupera(email))
				.unwrap()
				.then((res) => {
					handleShowModal();
				});
		}
	};

	const getMessageModal = () => {
		return (
			<>
				E' stata inviata un' e-mail per il recupero della pratica all' indirizzo&nbsp;
				<span className="font-weigth-bold m-0">
					{userInfo?.email || reopenPratica?.userData?.email}
				</span>
				. <br></br>
			</>
		);
	};

	const emailHandleChange = (value: string) => {
		dispatch(authRecuperaPraticaEmail(value));
	};

	return (
		<>
			<Col sm={12} md={4} className="side-cards">
				<Card className="shadow background-gray">
					<Card.Body>
						<div>
							<Accordion activeKey={!isDesktop || !!email ? "0" : undefined} alwaysOpen>
								<Accordion.Item className="border-0 background-gray" eventKey="0">
									<Accordion.Header id="recupera-pratica-accordion">
										<h5 className="px-3 background-gray">Recupera la tua pratica interrotta!</h5>
									</Accordion.Header>
									<Accordion.Body>
										<div className="mb-3">
											<span className="gray m-0">
												Inserisci l'e-mail utilizzata in fase di registrazione.
											</span>
										</div>
										<form onSubmit={(e) => handleRecuperaPratica(e)}>
											<BftInput
												type={"email"}
												name={"emailPratica"}
												placeholder={"Email"}
												containerStyle={{ padding: "0" }}
												value={email}
												onChange={(event) => emailHandleChange(event.target.value)}
											/>

											<div>
												<BftButton
													type="submit"
													className="btn-buffetti-secondary col-12"
													isDisabled={email == ""}
												>
													Recupera
												</BftButton>
											</div>
										</form>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</div>
					</Card.Body>
				</Card>
			</Col>

			<MessageModal
				show={showModal}
				onClose={handleCloseModal}
				message={getMessageModal()}
				title="Recupera Pratica"
			/>
		</>
	);
};

export default RecuperaPraticaCard;
